import React, { useState } from "react";
import { toast } from "react-toastify";
import { baseUrl } from "./baseUrl";
import axios from "axios";

const FactorDescription = (props) => {
    const [commentText, setCommentText] = useState("");
    const [loading, setLoading] = useState(false);
    const commentHandler = (e) => {
        setLoading(true);
        e.preventDefault();
        if (!commentText) {
            toast.error("لطفا تمام فیلدها را پر کنید", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLoading(false);
        } else {
            let data = new FormData();
            data.append("comment", commentText);
            let config = {
                url: `${baseUrl}/orders/${props.factorId}/comment`,
                method: "POST",
                data: data,
            };
            axios(config)
                .then((res) => {
                    toast.success("توضیحات با موفقیت ثبت شد", {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setLoading(false);
                    props.setShow(false);
                })
                .catch((err) => {
                    toast.error(err?.response?.data?.message, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setLoading(false);
                });
        }
    };
    return (
        <div className="factor-main">
            <div className="fac-modal des-mains">
                <div className="des-title">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
                            stroke="#f15a22"
                            strokeWidth="1.5"
                            strokeMiterlimit="10"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            opacity="0.4"
                            d="M7 8H17"
                            stroke="#f15a22"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            opacity="0.4"
                            d="M7 13H13"
                            stroke="#f15a22"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    توضیحات فاکتور
                </div>

                <div className="text-box">
                    <textarea
                        onChange={(e) => {
                            setCommentText(e.target.value);
                        }}
                        value={commentText}
                        placeholder="توضیحات"
                        className="text-box-div text-area-d"
                    ></textarea>
                    {!loading ? (
                        <button onClick={commentHandler}>ثبت </button>
                    ) : (
                        <button>
                            <img src="/assets/images/loading.gif" width={20} />
                        </button>
                    )}
                </div>
                {/* <div className="p-box">
                    <p>
                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت
                        چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون
                        بلکه روزنامه و مجله در ستون.
                    </p>
                </div> */}
            </div>
        </div>
    );
};

export default FactorDescription;
